<div [formGroup]="form" class="d-flex align-items-center justify-content-between advance-option-wrapper" *ngIf="isOverrideFlange">
    <mat-label class="mat-label-general me-7">
        <!-- Override FLange Details -->
        {{ 'STANDARD_FLANGE_PAGE.LABELS.CALC_INPUT.OVERRIDE_FLANGE_DETAILS' | transloco }}
    </mat-label>
    <mat-checkbox class="checkbox-wrap" name="override_flange" formControlName="enableOveride"></mat-checkbox>
</div>
